let commandMapping = {
    'read_so':'specialOffer/setList',
    'read_so_entry':'specialOffer/setEntryList',
    'read_so_entry_price':'specialOffer/setPriceList',
    'delete_order_tag':'specialOffer/delete_order_tag_return',
    'read_purchase':'purchaseRequisition/setList',
    'read_purchase_entry':'purchaseRequisition/setEntryList',
    'make_source':'eorderetails/setData',
    'make_dry':'eorderetails/setData',
    'purchase_picker':'eorderetails/setList',
    'make_order':'eorderetails/make_order_return',
    'read_order':'purchaseOrder/setList',
}
export default {
    commandMapping
}
